import React from 'react';
import styles from './DataLakeSettingsTab.module.css';
import KeyIndicator from './KeyIndicator';
import { FieldRenderProps, SelectCardProps } from './types';

const SelectCard: React.FC<FieldRenderProps & SelectCardProps> = ({
  field, draft, initialDraft, showKeys, highlighted, saving, onNumberChange, options, emptyLabel, hint,
}) => {
  const value = draft[field.key] ?? '';
  const isModified = value !== (initialDraft[field.key] ?? '');
  return (
    <div className={`${styles.card} ${highlighted ? styles.cardHighlight : ''}`}>
      <div className={styles.cardHeader}>
        <span className={styles.cardLabel}>
          {field.label}
          <KeyIndicator field={field} showKeys={showKeys} />
        </span>
        {isModified && <span className={styles.modifiedBadge}>Modified</span>}
      </div>
      <p className={styles.cardDescription}>{field.description}</p>
      <select
        className={styles.cardInput}
        value={value}
        disabled={saving}
        onChange={e => onNumberChange(field.key, e.target.value)}
      >
        <option value="">{emptyLabel}</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {hint && <span className={styles.defaultHint}>{hint}</span>}
    </div>
  );
};

export default SelectCard;
